import e from"./CurrentRefinements.vue_vue&type=script&lang.js";import{render as t}from"./CurrentRefinements.vue_vue&type=template&id=5584328f&lang.js";e.render=t;export default e;
//# sourceMappingURL=CurrentRefinements.vue.js.map
